// @ts-nocheck
import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';
import { AppProps } from './App';

const formatProducts = (products, campaign) => {
  const canRenderPrice = !campaign.hiddenPrice;

  return products.map((membership, index) => ({
    id: `membership-${index}`,
    name: membership.title,
    discount:
      canRenderPrice && membership.prices.discount > 0
        ? `${membership.prices.discount}% Dto`
        : null,
    description: membership.fullDescription,
    buttonLabel: campaign.buttonLabel,
    benefits: membership.benefitsV2,
    backgroundImage: {
      small: campaign.backgroundTabletImage,
      big: campaign.backgroundImage,
    },
    url: membership.urlCheckout,
    prices: canRenderPrice
      ? {
          currency: membership.prices.currencySymbol,
          price: membership.prices.total,
          realPrice: membership.prices.realPrice,
        }
      : null,
  }));
};

const getInitialState: GetInitialStateInner<AppProps> = ({
  campaign,
  memberships,
}) => {
  // const canRenderPrice = !campaign.hiddenPrice;
  const _memberships = memberships?.edges?.map(el => el.node) || [];

  return {
    promoBar: campaign.promoBar.expirationDate
      ? {
          message: campaign.promoBar.largeMessage,
          shortMessage: campaign.promoBar.shortMessage,
          expirationDate: new Date(campaign.promoBar.expirationDate),
        }
      : null,
    headerSection: {
      title: campaign.title,
      subtitle: campaign.subtitle,
      logoUrl: campaign.logoImageUrl,
      externalLink: campaign.externalLink
        ? {
            label: campaign.externalLink.externalLinkText,
            url: campaign.externalLink.externalLinkUrl,
          }
        : null,
    },
    products: formatProducts(_memberships, campaign),
    legalsCopy: campaign.extraMessage,
  };
};

export default getInitialState;
